export default "dist/images/components-columns-width-control-4-1.ba54e2f.png";